<div id="sandhub-workarea">
  <div class="title-bar-area">
    <div class="title-area">Whiteboards</div>
    <!--<div class="video-icon" (click)="openPopup()"><i class="far fa-video"></i></div>
    <app-video-modal *ngIf="showPopup==true" [videoUrl]="videoDetail" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>-->
  </div>
</div>

<div>
  <app-tile-container [showAdd]="true"
                      (addNew)="addNewTile()"
                      [tiles]="tiles"
                      [tileTemplate]="tileTemplate"
                      (sortOrderChanged)="orderChange($event)"
                      [size]="'xlarge'"
                      (tilePinnedChange)="addTileToast($event)"></app-tile-container>
</div>

<ng-template #tileTemplate let-model="model">
  <div (click)="activateLink(model)" class="tile-content">

    <div class="tile-content-header miro-color">
      <div class="miro-tile-title">
        {{ model.name }}
      </div>
    </div>

    <!--<div class="tile-content-sub-header miro-color"style="margin-top:30px;">
      {{ model.description }}
    </div>-->

    <div class="" *ngIf="model?.imageUrl">
      <img [src]="model.imageUrl" alt="An image of the {{model.name}} board" class="imgsize" />
    </div>


    <div class="tile-content-footer miro-color">
      Owner: {{ model.owner }}
    </div>
  </div>
</ng-template>
